<template>
  <div class="d-flex align-items-center">

    <b-modal v-model="showModal" title="Share Project via email" hide-footer size="lg">
      <share-project-email-form :project-id="projectId" @sentEmail="showModal = false"/>
    </b-modal>

    <switch-input :name="name" :value="value" :url="url" :disabled="false" @checked="isShared = arguments[0]" v-b-tooltip :title="isShared ? 'Disable sharing' : 'Enable sharing'"/>

    <div v-if="isShared">

      <a :href="shareableUrl" class="font-size-sm" target="_blank">{{shareableUrl}}</a>

      <b-button class="p-0" variant="link" v-b-tooltip title="Copy Link to Clipboard" @click="copyLink">
        <i class="fas fa-copy"></i>
      </b-button>
      <b-button class="p-0" variant="link" v-b-tooltip title="Share Link via Email" @click="showModal = true">
        <i class="fas fa-envelope"></i>
      </b-button>
    </div>
    <div v-else>Make this project collection shareable publicly</div>
  </div>

</template>

<script>

import SwitchInput from "../../Common/SwitchInput.vue";
import GeneralMixins from "../../../mixins/GeneralMixins.js";
import ShareProjectEmailForm from "./ShareProjectEmailForm.vue";

export default {
  props: ['name', 'value', 'url', 'shareableUrl', 'projectId'],
  mixins: [GeneralMixins],

  data() {
    return {
      isShared: this.value === "true",
      showModal: false,
    }
  },

  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.shareableUrl)
      this.showToast(`Link was copied to clipboard`)
    }
  },

  components: {ShareProjectEmailForm, SwitchInput}
}
</script>